import { Form as EditPortfolioPageForm } from '@/components/portfolio_pages/edit_form'
import { Form as NewPortfolioPageForm } from '@/components/portfolio_pages/new_form'
import { EditEventQuery } from './__generated__/edit_query'
import { Query } from './edit_query'
import { useQuery } from '@apollo/client/react'
import { Inline as Loading } from '@/components/loading'

interface Props {
  eventId: string
}

export const EditPortfolioPage = ({ eventId }: Props) => {
  const { data, loading } = useQuery<EditEventQuery>(Query, { variables: { filters: { idEq: eventId }, first: 1 } })

  if (loading || !data) return <Loading />

  if (data.events.nodes[0]?.portfolioPage?.id) {
    return <EditPortfolioPageForm id={data.events.nodes[0].portfolioPage.id} onSuccess={() => {}} />
  } else {
    return <NewPortfolioPageForm defaultValues={{ eventId }} onSuccess={() => {}} />
  }
}
